<!-- 洪城通公交车DIY -->
<template>
  <div class="page">
    <b-container fluid>
      <b-row>
        <b-col cols="8" class="mx-auto">
          <b-img src="static/hongchengDIY/洪城通DIY卡-03.jpg" fluid />
        </b-col>
      </b-row>

      <div>
        <hr />
        <!-- 姓名 -->
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-name">姓名</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="name"
              id="input-name"
              type="text"
              placeholder="请输入办卡人姓名"
              :state="nameError ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback v-if="nameError">{{
              nameErrorMessage
            }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <hr />
        <!-- 手机号 -->
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">手机号</label>
          </b-col>
          <b-col cols="6">
            <b-form-input
              v-model="mobile"
              id="input-mobile"
              type="tel"
              maxlength="11"
              placeholder="请输入手机号"
              :state="mobileError ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback v-if="mobileError">{{
              mobileErrorMessage
            }}</b-form-invalid-feedback>
          </b-col>
          <b-col cols="3">
            <b-button
              block
              variant="primary"
              style="font-size: 12px"
              @click="getCore()"
              >验证码</b-button
            ></b-col
          >
        </b-row>
        <hr />
        <!-- 手机验证码 -->
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">验证码</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="verificationCode"
              id="input-mobile"
              type="tel"
              maxlength="11"
              placeholder="请输入验证码"
              :state="verificationCodeError ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback v-if="verificationCodeError">{{
              verificationCodeErrorMessage
            }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <!-- 验证码 -->
          <b-col>
            <div style="text-align: center; font-size: 0.6rem">
              同一手机号当天只能发送10次验证码
            </div>
          </b-col></b-row
        >
        <hr />
        <!-- 请选择取卡方式 -->
        <!-- <b-row class="rowItem">
          <b-col cols="3">
            <label>请选择取卡方式</label>
          </b-col>
          <b-col cols="9">
            <van-radio-group v-model="radio" direction="horizontal">
              <van-radio name="1">自提</van-radio>
              <van-radio name="2">邮寄</van-radio>
            </van-radio-group>
          </b-col>
        </b-row>
        <hr /> -->
        <!-- 选择自提网点-->
        <b-row class="rowItem" v-if="ziTi">
          <b-col cols="3">
            <label>客服中心</label>
          </b-col>
          <b-col cols="9">
            <b-form-select
              id="wangDianID"
              v-model="wangdian"
              :options="wangdian_options"
            ></b-form-select>
          </b-col>
        </b-row>

        <!-- 填写您的邮寄地址 -->
        <b-row class="rowItem" v-if="youJi">
          <hr />
          <b-col cols="3">
            <label>请填写邮寄地址</label>
          </b-col>
          <!-- 省 -->
          <b-col cols="9">
            <b-form-select
              id="provinceIdProvince"
              v-model="provinceText"
              :options="provinceS"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-col>
          <!-- 市 -->
          <b-col cols="3">
            <label></label>
          </b-col>
          <b-col cols="9">
            <b-form-select
              id="provinceIdCity"
              v-model="cityText"
              :options="cityS"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-col>
          <!-- 县区 -->
          <b-col cols="3">
            <label></label>
          </b-col>
          <b-col cols="9">
            <b-form-select
              id="provinceIdCounty"
              v-model="countyText"
              :options="countyS"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-col>
          <b-col cols="12">
            <label></label>
          </b-col>
          <b-col cols="3">
            <label></label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="address"
              id="input-address"
              type="text"
              placeholder="请填写具体地址（街道、小区、门牌号）"
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />

        <!-- 同意协议 -->
        <b-row>
          <b-col cols="1">
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />
          </b-col>

          <b-col>
            我已阅读<font color="red" @click="showRules()"
              >《洪城通DIY卡使用章程》</font
            >并同意相关内容。
          </b-col>
        </b-row>
        <!-- 同意协议 -->
        <b-row class="rowItemFee">
          <b-col cols="1"> </b-col>
          <b-col> 下一步将提交申请图片进行处理及卡片费用结算。 </b-col>
        </b-row>

        <!-- 下一步 -->
        <b-row class="rowBtn">
          <b-col cols="10" class="mx-auto">
            <b-button
              block
              variant="danger"
              :disabled="disabled"
              @click="commitUserInfo()"
              >下一步</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- 协议内容 -->
      <b-modal
        ref="rules"
        ok-only
        scrollable
        title="公交卡使用章程"
        ok-title="确定"
      >
        <div
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <label>持卡人须知：</label>
          <label>1、本卡不记名、不挂失、可反复充值使用。</label>
          <label>2、使用请遵守《交通一卡通使用须知》及相关规定。</label>
          <label>3、使用本卡请妥善保管，请勿弯折。</label>
          <label
            >4、本卡支持带有NFC功能的安卓手机使用洪城通出行APP贴卡充值。</label
          >
          <label>5、本卡最终解释权归市公共交通集团有限责任公司所有。</label>
        </div>
      </b-modal>
      <!-- 报错原因 -->
      <b-modal
        ok-only
        ref="model_error"
        title="提示"
        @ok="handleOk"
        ok-title="确定"
      >
        <p>{{ errorMsg }}</p>
      </b-modal>
      <b-modal
        ok-only
        ref="mobile_error"
        title="提示"
        @ok="handleOk"
        ok-title="确定"
      >
        <p>{{ mobileErrorInfo }}</p>
      </b-modal>
      <!-- 借记卡数量 -->
      <!-- <b-modal
        ref="model_bank_confirm"
        title="提示"
        @ok="handleBankConfirm"
        ok-title="确定"
        cancel-title="取消"
      >
        <p>
          尊敬的客户，请确认您持有我公交公司公交卡数量！
        </p>
      </b-modal> -->
      <!-- 提示框：确定信息 -->
      <b-modal
        ref="model_user_info"
        title="提示"
        @ok="handleUserInfo"
        content-class="shadow"
        ok-title="确定"
        cancel-title="取消"
      >
        <b-row>
          <b-col> 普通卡申请信息如下，您是否申请普通卡？ </b-col>
        </b-row>
        <hr />
        <!-- 姓名 -->
        <b-row>
          <b-col cols="4"> 申卡人： </b-col>
          <b-col cols="8">
            {{ name }}
          </b-col>
        </b-row>
        <hr />
        <!-- 电话 -->
        <b-row>
          <b-col cols="4"> 手机号： </b-col>
          <b-col cols="8">
            {{ mobile }}
          </b-col>
          <b-col cols="4"></b-col>
          <b-col cols="8">
            <font color="red">(请确认手机号码是否填写正确，以免收不到卡)</font>
          </b-col>
        </b-row>
        <hr />
        <!-- 取卡方式 -->
        <b-row>
          <b-col cols="4"> 取卡方式 </b-col>
          <b-col cols="8">
            {{ radio === "1" ? "自提" : "邮寄" }}
          </b-col>
        </b-row>
        <b-row v-if="ziTi">
          <b-col cols="4"> 客服中心： </b-col>
          <b-col cols="8" class="itemWordWrap">
            {{ wangdianID }}
          </b-col>
        </b-row>
        <b-row v-if="youJi">
          <b-col cols="4"> 邮寄地址： </b-col>
          <b-col cols="8" class="itemWordWrap">
            {{ addressAll }}
          </b-col>
        </b-row>
      </b-modal>
      <!-- loading toast  提交中-->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">提交中</p>
        </div>
      </div>
      <div v-show="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <p class="weui-toast__content">{{ toastMsg }}</p>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
import { mobile_pattern } from "@/js/verifyData";
export default {
  name: "ApplyCard_hongcheng",
  mounted: function () {
    // 获取省信息
    this.getProvinceList();
    // 获取网点信息
    // this.getWangdian();
  },
  data() {
    return {
      status: "not_accepted",
      disabled: true,
      name: "", //姓名
      mobile: "", //手机号
      verificationCode: "", //验证码
      bankCode: null,
      wangdian: null, // 网点信息
      wangdian_options: [
        {
          value: null,
          text: "请选择客服中心",
          wangdian_address: null,
          wangdian_bankBranchCode: null,
        },
      ],
      wangdianID: null,
      wangdianAdd: null,
      wangdianBankBranchCode: null,
      errorMsg: "",
      loading: false,
      showToast: false,
      toastMsg: "",
      // 请选择取卡方式
      radio: "2",
      expressWay: 2, //邮寄方式
      ziTi: false, //自提
      youJi: true, //邮寄
      provinceText: "",
      // 省id
      provinceText: null,
      // 市id
      cityText: null,
      // 县区id
      countyText: null,
      // 省
      provinceS: [
        {
          value: null,
          text: "请选择省份",
        },
      ],
      //市
      cityS: [
        {
          value: null,
          text: "请选择市区",
        },
      ],
      //区
      countyS: [
        {
          value: null,
          text: "请选择县区",
        },
      ],
      address: null, //填写详细地址
      addressAll: null,
      mobileError: false,
      mobileErrorMessage: "手机号码格式不正确",
      mobileErrorInfo: "", //弹窗显示
      nameError: false,
      nameErrorMessage: "请输入正确的姓名",
      nameErrorInfo: "",
      verificationCodeError: false,
      verificationCodeErrorMessage: "请输入正确的验证码",
      verificationCodeErrorInfo: "",
    };
  },

  beforeRouteEnter(to, from, next) {
    // to=》自身   from=>从哪里来
    console.log("beforeRouteEnter");
    console.log("to", to);
    console.log("from", from);
    // if (from.name === 'Home_hongcheng') {
    //   to.meta.keepAlive = true;
    // } else if (from.name === 'SelectCardface_hongcheng') {
    //   from.meta.keepAlive = true;
    // }
    next();
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    console.log("to", to);
    console.log("from", from);
    if (to.name === "Home_hongcheng") {
      this.$router.go(0);
    }
    next();
  },

  methods: {
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    handleUserInfo: function () {
      this.getBankSn();
    },
    showUserInfo: function () {
      this.$refs["model_user_info"].show();
    },
    handleBankConfirm: function () {
      this.showUserInfo();
    },
    // 卡面数据弹窗
    // showBankConfirm: function() {
    //   this.$refs["model_bank_confirm"].show();
    // },
    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    mobileErrorMsg: function () {
      this.$refs["mobile_error"].show();
    },
    // 获取验证码
    getCore() {
      let param = this.mobile;
      if (this.mobile == "") {
        this.mobileErrorInfo = "请输入手机号码";
        this.mobileErrorMsg();
      } else if (!this.mobileError) {
        axios.get(config.config_hongcheng.getCore + param).then((res) => {
          console.log("res-->", res);
          let data = res.data;
          if (data.code == 200) {
            // 验证码获取成功
          } else if (data.code == 500) {
            this.mobileErrorInfo = data.message;
            this.mobileErrorMsg();
          }
        });
      }
    },
    // 验证验证码
    getVerificationCode() {
      let param = this.mobile + "/" + this.verificationCode;
      axios.get(config.config_hongcheng.verifyCore + param).then((res) => {
        console.log("res--->", res);
        let data = res.data;
        if (data.code == 200) {
          // 验证码验证成功
          this.handleBankConfirm();
        } else if (data.code == 500) {
          this.mobileErrorInfo = data.message;
          this.mobileErrorMsg();
        }
      });
    },
    // 获取网点信息
    getWangdian() {
      let that = this;
      var formData = new FormData();
      formData.append("parentId", "");
      let param = {
        bankCode: config.config_hongcheng.bankCode,
        ascriptionCode: config.config_hongcheng.bankCode,
      };
      // console.log("获取网点信息--->", param);
      axios
        .post(config.config_hongcheng.getBranchInfoNewByParam, param)
        .then((res) => {
          console.log("res--->", res);
          let data = res.data;
          var wandianInfos = new Array(data.length + 1);
          var obj = new Object();
          obj.value = null;
          obj.text = "请选择客服中心";
          wandianInfos[0] = obj;
          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let info = new Object();
            info.value = item.branch_code;
            info.text = item.branch_name;
            info.wangdian_address = item.branch_address;
            info.wangdian_bankBranchCode = item.branch_code;
            wandianInfos[i + 1] = info;
          }
          that.wangdian_options = wandianInfos;
          console.log("wandianInfos--->", wandianInfos);
          console.log("wandianInfos1--->", wandianInfos[1].wangdian_address);
        });
    },
    // 获取省份信息
    getProvinceList() {
      var formData = new FormData();
      formData.append("parentId", "");
      axios.post(config.config_ql.getProvinceInfoList, formData).then((res) => {
        let that = this;
        let data = res.data;
        var shengList = new Array(data.length + 1);
        var obj = new Object();
        obj.value = null;
        obj.text = "请选择省份";
        shengList[0] = obj;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          let info = new Object();
          info.value = item.id;
          info.text = item.name;
          shengList[i + 1] = info;
        }
        that.provinceS = shengList;
      });
    },
    // 提交信息
    getBankSn: function () {
      if (this.radio === "1") {
        let that = this;
        this.bankCode = config.config_hongcheng.bankCode;
        let address_ziti = this.wangdianID + this.wangdianAdd;
        let param = {
          clientName: this.name, //姓名
          clientPhoneNumber: this.mobile, //电话
          bankCode: this.bankCode, //银行编号
          bankSubCode: "", //分行编码
          bankBranchCode: this.wangdianBankBranchCode, //支行|网点编码
          bankSerialNumber: "", //银行唯一号
          address: address_ziti,
          expressWay: this.expressWay, //邮寄方式
        };
        console.log("param--->", param);
        that.showLoading();
        axios
          .post(config.config_hongcheng.submitUserInfo, param)
          .then(function (response) {
            that.hideLoading();
            console.log("response--->", response);
            let data = response.data;
            if (data.code == 0) {
              that.toSelectCardFace(data.backSerialNumber, data.bankCode);
            } else {
              console.log("提交用户信息失败：" + data.message);
              that.errorMsg = data.message;
              that.showErrorMsg();
            }
          });
      } else {
        let that = this;
        this.bankCode = config.config_hongcheng.bankCode;
        let param = {
          clientName: this.name, //姓名
          clientPhoneNumber: this.mobile, //电话
          bankCode: this.bankCode, //银行编号
          bankSubCode: "", //分行编码
          bankBranchCode: "", //支行|网点编码
          bankSerialNumber: "", //银行唯一号
          address: this.addressAll, //邮寄地址
          expressWay: this.expressWay, //邮寄方式
        };
        console.log("param--->", param);
        that.showLoading();
        axios
          .post(config.config_hongcheng.submitUserInfo, param)
          .then(function (response) {
            that.hideLoading();
            console.log("response--->", response);
            let data = response.data;
            if (data.code == 0) {
              that.toSelectCardFace(data.backSerialNumber, data.bankCode);
            } else {
              console.log("提交用户信息失败：" + data.message);
              that.errorMsg = data.message;
              that.showErrorMsg();
            }
          });
      }
    },
    // 是否填写全部信息
    commitUserInfo: function () {
      this.getaddressAll();
      this.getWangDianadd();
      const pattMobile = mobile_pattern;
      if (
        this.name.length == 0 ||
        this.name.length < 2 ||
        this.name.length > 15
      ) {
        this.showToastMsg("您输入的姓名长度不符合要求，请重新输入");
        return;
      }

      if (!pattMobile.test(this.mobile)) {
        this.showToastMsg("请输入正确的手机号");
        return;
      }
      if (this.verificationCode == "") {
        this.showToastMsg("请输入验证码");
        return;
      }

      if (this.radio == "") {
        this.showToastMsg("请选择取卡方式");
        return;
      }
      if (this.radio === "1") {
        // 自提方式
        if (this.wangdian == null) {
          this.showToastMsg("请选择客服中心");
          return;
        }
      }
      if (this.radio === "2") {
        // 邮寄方式
        if (
          this.provinceText == null ||
          this.cityText == null ||
          this.countyText == null ||
          this.address == null
        ) {
          this.showToastMsg("请选择邮寄地址");
          return;
        }
      }
      // this.handleBankConfirm();

      // 验证码的正确性
      this.getVerificationCode();
    },
    // 页面跳转
    toSelectCardFace: function (bankSerialNumber, bankCode) {
      this.$router.push({
        name: "SelectCardface_hongcheng",
        query: {
          bankSerialNumber: bankSerialNumber,
          bankCode: bankCode,
          radio: this.radio,
        },
      });
    },
    showRules: function () {
      this.$refs["rules"].show();
    },
    // 取卡方式
    cardRetrievalMethod() {
      if (this.radio === "1") {
        this.ziTi = true;
        this.youJi = false;
      } else if (this.radio === "2") {
        this.ziTi = false;
        this.youJi = true;
      }
    },
    // 获取网点具体信息
    getWangDianadd() {
      if (this.radio === "1") {
        var myselectWangDian = document.getElementById("wangDianID");
        var wangdian_address_wangdian =
          document.getElementById("wangDianID").options[
            myselectWangDian.selectedIndex
          ].value;
        let addStr = Number(wangdian_address_wangdian);
        this.wangdianAdd = this.wangdian_options[addStr].wangdian_address;
        this.wangdianBankBranchCode =
          this.wangdian_options[addStr].wangdian_bankBranchCode;
        // console.log(
        //   "wandianInfos1--->",
        //   this.wangdian_options[addStr].wangdian_address
        // );
      }
    },
    // 获取所有地址
    getaddressAll() {
      if (this.radio === "1") {
        var myselectWangDian = document.getElementById("wangDianID");
        var text_wangdian =
          document.getElementById("wangDianID").options[
            myselectWangDian.selectedIndex
          ].text;
        this.wangdianID = text_wangdian;
        console.log("this.wangdianID--->", text_wangdian);
      } else {
        var myselectProvince = document.getElementById("provinceIdProvince");
        var text_province =
          document.getElementById("provinceIdProvince").options[
            myselectProvince.selectedIndex
          ].text;
        var myselectCity = document.getElementById("provinceIdCity");
        var text_city =
          document.getElementById("provinceIdCity").options[
            myselectCity.selectedIndex
          ].text;
        var myselectCounty = document.getElementById("provinceIdCounty");
        var text_county =
          document.getElementById("provinceIdCounty").options[
            myselectCounty.selectedIndex
          ].text;

        this.addressAll =
          text_province + text_city + text_county + this.address;
        console.log("this.addreaaAll--->", this.addressAll);
      }
    },
    validateMobile(mobile) {
      // 使用正则表达式验证手机号码
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(mobile)) {
        this.mobileError = true;
      } else {
        this.mobileError = false;
      }
    },
    validateName(name) {
      const nameRegex = /^([\u4e00-\u9fa5]{2,15}|[A-Za-z\s'-]+)$/u;
      if (!nameRegex.test(name)) {
        this.nameError = true;
      } else {
        this.nameError = false;
      }
    },
    validateVerificationCode(verificationCode) {
      const verificationCodeRegex = /^\d{6}$/;
      if (!verificationCodeRegex.test(verificationCode)) {
        this.verificationCodeError = true;
      } else {
        this.verificationCodeError = false;
      }
    },
  },

  updated() {
    this.cardRetrievalMethod();
  },
  watch: {
    mobile(newVal, oldval) {
      this.validateMobile(newVal);
    },
    name(newVal, oldval) {
      this.validateName(newVal);
    },
    verificationCode(newVal, oldval) {
      this.validateVerificationCode(newVal);
    },
    status: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (newval == "accepted") {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    // 监听省下拉框
    provinceText: function (newval, oldval) {
      if (newval == null) {
        this.cityText = null;
        this.cityS = [
          {
            text: "请选择市区",
            value: null,
          },
        ];
        return;
      } else {
        // 获取市的数据
        this.cityText = null;
        var formData = new FormData();
        formData.append("parentId", newval);
        axios
          .post(config.config_ql.getCityInfoByParam, formData)
          .then((res) => {
            let that = this;
            let data = res.data;
            var shiList = new Array(data.length + 1);
            var obj = new Object();
            obj.value = null;
            obj.text = "请选择市区";
            shiList[0] = obj;
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              let info = new Object();
              info.value = item.id;
              info.text = item.name;
              shiList[i + 1] = info;
            }
            that.cityS = shiList;
          });
      }
    },
    // 监听市下拉框
    cityText: function (newval, oldval) {
      if (newval == null) {
        this.countyText = null;
        this.countyText = [
          {
            text: "请选择县区",
            value: null,
          },
        ];
        return;
      } else {
        // 获取县区的数据
        this.countyText = null;
        var formData = new FormData();
        formData.append("parentId", newval);
        axios
          .post(config.config_ql.getDistrictInfoByParam, formData)
          .then((res) => {
            let that = this;
            let data = res.data;
            var quList = new Array(data.length + 1);
            var obj = new Object();
            obj.value = null;
            obj.text = "请选择县区";
            quList[0] = obj;
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              let info = new Object();
              info.value = item.id;
              info.text = item.name;
              quList[i + 1] = info;
            }
            that.countyS = quList;
          });
      }
    },
    // 邮寄方式 radio  expressWay
    radio: function (newval, oldval) {
      if (newval === "1") {
        this.expressWay = 1;
      } else {
        this.expressWay = 2;
      }
    },
  },
};
</script>

<style scoped>
.rowItem {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.rowItemFee {
  margin-top: 1rem;
}

.rowBtn {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.page {
  margin-top: 4vh;
}

.img {
  width: 100%;
}

.innerText {
  text-indent: 2rem;
}

.itemWordWrap {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/hongcheng/ApplyCard_hongcheng.vue